import { MoreHorizontal } from "lucide-react";
import { useEffect, useId, useRef, useState, type ReactNode } from "react";

export function ReaderOverflowMenu({ label = "Ещё действия", children }: { label?: string; children: ReactNode }) {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLDivElement>(null);
  const toggleRef = useRef<HTMLButtonElement>(null);
  const id = useId();
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => { if (event.key === "Escape") { setOpen(false); toggleRef.current?.focus(); } };
    const onPointer = (event: MouseEvent) => {
      if (!wrapRef.current) return;
      if (!wrapRef.current.contains(event.target as Node)) setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    document.addEventListener("mousedown", onPointer);
    return () => {
      document.removeEventListener("keydown", onKey);
      document.removeEventListener("mousedown", onPointer);
    };
  }, [open]);
  return <div className={open ? "reader-overflow open" : "reader-overflow"} ref={wrapRef}>
    <button
      type="button"
      className="reader-more"
      ref={toggleRef}
      aria-controls={id}
      aria-expanded={open}
      aria-label={label}
      onClick={() => setOpen((value) => !value)}
    ><MoreHorizontal size={17} /></button>
    {open && <div id={id} className="reader-overflow-menu" role="group" aria-label={label} onClick={event => { if (!(event.target as Element).closest(".stateful-button, .action-error")) { setOpen(false); toggleRef.current?.focus(); } }}>{children}</div>}
  </div>;
}
